import { render, staticRenderFns } from "./PreviewPhone.vue?vue&type=template&id=d6d63126&scoped=true"
import script from "./PreviewPhone.vue?vue&type=script&lang=js"
export * from "./PreviewPhone.vue?vue&type=script&lang=js"
import style0 from "./PreviewPhone.vue?vue&type=style&index=0&id=d6d63126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d63126",
  null
  
)

export default component.exports